function gridCarousel() {

    jQuery(document).ready(function ($) {
        $('.component--grid').each(function () {
            const grid = $(this).find('.grid-splide')[0];
            if (grid) {
                new Splide(grid).mount();
            }
        })
    });

    gsap.registerPlugin(ScrollTrigger);

    if (window.innerWidth > 768) {

        gsap.utils.toArray('.fixed-panel-container').forEach(container => {
            gsap.utils.toArray('.panel-inner', container).forEach((panel) => {
                ScrollTrigger.create({
                    trigger: panel,
                    start: 'top top',
                    // start: 'bottom bottom',
                    pin: true,
                    pinSpacing: false,
                    // end: () => "+=" + panel.offsetHeight,

                });
            });
        });
    }

}

export default gridCarousel;